<template>
  <el-dialog
    custom-class="import-dialog"
    title="添加分组"
    :visible="visible"
    @close="close"
  >
    <div class="p20">
      <div class="table-panel flex flex-end">
        <el-input
          class="mr10"
          size="small"
          v-model="groupName"
          placeholder="请输入分组名称"
        ></el-input>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
      <div class="table-wrapper">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          @current-change="getCheckedEmployee"
          highlight-current-row
          :data="groupList"
          style="width: 100%"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商品分组"
            prop="groupName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="relNum"
            label="商品数量"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="groupListTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      currentRow: {},
      groupName: "",
      groupListTotal: 0,
      groupList: [],
      currentPage: 1,
      pageSize: 10
    };
  },
  watch: {
    goodsDetails(val) {
      if (val) {
        this.$emit("setGoodsInfo", val);
        this.close();
      }
    }
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    getCheckedEmployee(selection) {
      this.currentRow = selection;
    },
    save() {
      if (!this.currentRow.groupId) {
        this.$message({
          type: "warning",
          message: "请先选择商品"
        });
      } else {
        this.$emit("saveGroupGoods", this.currentRow);
      }
    },
    close() {
      this.$emit("close");
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryGoodsGroupList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        groupName: this.groupName
      });
      const { records, total } = result;
      this.groupList = records;
      this.groupListTotal = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
